import React, { useRef } from 'react'
import HomeContent from '../components/organisms/homeContent/homeContent'
import PageLayout from '../components/templates/page-layout/page-layout'
import Slider from 'react-slick'
import useMediaQuery from '../utils/useMediaQuery'

function IndexPage() {
  const isMobile = useMediaQuery()
  const slider = useRef(null)
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    draggable: false,
    swipe: false,
    touchMove: false,
  }

  return (
    <PageLayout>
      {isMobile ? (
        <Slider {...settings} ref={slider} className="f-slider-home-container">
          <HomeContent
            isMobile={isMobile}
            onHandleNext={() => slider.current.slickNext()}
            type="penis"
          />
          <HomeContent
            isMobile={isMobile}
            onHandleNext={() => slider.current.slickNext()}
            type="menstruacion"
          />
          <HomeContent
            isMobile={isMobile}
            onHandleNext={() => slider.current.slickNext()}
            type="zonaV"
          />
        </Slider>
      ) : (
        <HomeContent isMobile={isMobile} />
      )}
    </PageLayout>
  )
}

export default IndexPage
